module.exports = __webpack_public_path__ + "wood-ico.png?3c0db6426d1ad243ff6c2fccdb44266e";